/**
 * 生成UUID v4
 * @returns {string} 返回一个UUID字符串
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0;
    const v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}

/**
 * 生成简化的UUID（去掉横线）
 * @returns {string} 返回一个32位的UUID字符串
 */
export function generateSimpleUUID(): string {
  return generateUUID().replace(/-/g, '');
}

/**
 * 生成指定长度的随机字符串
 * @param length 字符串长度
 * @returns {string} 返回指定长度的随机字符串
 */
export function generateRandomString(length: number): string {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
} 